import { useState } from 'react';
import { Autocomplete, Box, IconButton, TextField } from '@mui/material';
import { Add as PlusIcon } from '@mui/icons-material';
import { ProductFeature } from '@localstack/types';

import { FEATURE_NAME_MAPPING } from './constants';

const DEFAULT_FEATURE = ProductFeature.FEATURE_LOCALSTACK_PRO;
const DEFAULT_VARIANT = '';
const DEFAULT_VERSION = '*.*.*';

export interface SubscriptionFeatureFormProps {
  onAddFeature: (feature: [ProductFeature, string, string]) => void;
}

export const SubscriptionFeatureForm = ({ onAddFeature }: SubscriptionFeatureFormProps): JSX.Element => {
  const [editedFeatureName, setEditedFeatureName] = useState<ProductFeature>(DEFAULT_FEATURE);
  const [editedFeatureVariant, setEditedFeatureVariant] = useState<string>(DEFAULT_VARIANT);
  const [editedFeatureVersion, setEditedFeatureVersion] = useState<string>(DEFAULT_VERSION);

  return (
    <Box width="100%">
      <Autocomplete
        size="small"
        clearIcon
        fullWidth
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        options={Object.values(ProductFeature as Record<string, string>)}
        getOptionLabel={(r) => FEATURE_NAME_MAPPING[r as ProductFeature]}
        renderInput={(params) => <TextField {...params} label="Feature" variant="outlined" />}
        value={editedFeatureName}
        onChange={(_e, r) => r && setEditedFeatureName(r as ProductFeature)}
      />
      <Box display="flex" mt={2}>
        <Box flexGrow={1}>
          <TextField
            fullWidth
            size="small"
            label="Variant"
            variant="outlined"
            value={editedFeatureVariant}
            onChange={(e) => setEditedFeatureVariant(e.target.value)}
          />
        </Box>
        {/* Hidden for now not to distract admins, since versions are not being respected by localstack atm */}
        <Box flexGrow={1} ml={2} display="none">
          <TextField
            fullWidth
            size="small"
            label="Version"
            variant="outlined"
            value={editedFeatureVersion}
            onChange={(e) => setEditedFeatureVersion(e.target.value)}
          />
        </Box>
        <Box>
          <IconButton
            color="primary"
            onClick={() => {
              onAddFeature([editedFeatureName, editedFeatureVariant, editedFeatureVersion]);
              setEditedFeatureVariant(DEFAULT_VARIANT);
              setEditedFeatureVersion(DEFAULT_VERSION);
              setEditedFeatureName(DEFAULT_FEATURE);
            }}
          >
            <PlusIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};
